import { Typography, Stack, Box } from "@mui/material";
import { WarningAmber } from "@mui/icons-material";
import { useTranslation } from "react-i18next";

export default function LargeWarningDisplay({ title, message }) {
  const { t } = useTranslation();

  return (
    <Stack
      alignItems="center"
      justifyContent="center"
      textAlign="center"
      spacing={2}
      sx={{
        height: "100%",
        px: 4,
        flexGrow: 1,
      }}
    >
      <WarningAmber
        sx={{
          fontSize: { xs: 80, sm: 100 },
          color: "warning.main",
        }}
      />

      <Box>
        <Typography variant="h6" gutterBottom>
          {t(title)}
        </Typography>
        <Typography variant="body1" color="text.secondary">
          {t(message)}
        </Typography>
      </Box>
    </Stack>
  );
}
